import classNames from 'classnames';

import Message from 'types/Message';
import Typography from '@components/atoms/Typography';
import CheckList from '@components/atoms/CheckList';

import classes from './ExpertSection.module.scss';

export type Props = {
  title: Message;
  titleDescription?: Message;
  description: Message;
  items: {
    text: Message;
    id: number;
  }[];
  className?: string;
  itemsPerRow: number;
};

const ExpertSection = ({ title, titleDescription, description, className, items, itemsPerRow }: Props): JSX.Element => (
  <div className={classNames(className, classes.wrapper)}>
    <div>
      <Typography variant="h1" renderAs="div" className={classes.title}>
        {title}
      </Typography>
      <Typography variant="h2" renderAs="div" className={classes.titleDescription}>
        {titleDescription}
      </Typography>
    </div>
    <div className={classes.secondWrapper}>
      <Typography variant="h2" renderAs="p">
        {description}
      </Typography>
      <CheckList listStyle="unordered" size="h2" itemsPerRow={itemsPerRow} color="blue">
        {items.map(({ text, id }) => (
          <CheckList.Item key={id}>{text}</CheckList.Item>
        ))}
      </CheckList>
    </div>
  </div>
);

export default ExpertSection;
